import { translator } from 'core/localization/localization';

export const i18n = translator({
	'Make available in subaccount': {
		no: 'Gjør tilgjengelig i subkontoer',
	},
});
